import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'new_professional',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.addresses[props.index] = next
    })
  }
}
